import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import "./auth.scss";
import {
    emailValidation,
    noSpaceOnChange,
    phoneValidation,
} from "../../validations/validation";

import { forgotPassword } from "../../service/api/user/forgotPassword";
import InputField from "../../jsx/components/fields/inputField";
import { validateSecurityCode } from "../../service/api/user/validateSecurityCode";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { activateUser } from "../../service/api/user/activationCode";
import { resendCode } from "../../service/api/user/resendActivationCode";
import { verifySecurityCodeApi } from "../../service/api/user/verifySecurityCode";
import outerMainBannerImg from "../../media/images/authAssets/outerMainBannerImg.png";
import logo from "../../icons/photos/chillLogo.png";
import { btnAlreadyAUser, btnResendCode, btnVerify, hintEnterValidationCode, txtANewWay } from "../../dataBaseFile/label";
import { authenticate } from "../../feature/authSlice";
import { setIsSignUpFlagTrue, setUserDetails } from "../../feature/userData/userData";
const ActivateUser = ({ hanldleChangeMyMailOrPhone }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loaderActive, setLoaderActive] = useState(false);

    const [recievedCodeValue, setRecievedCodeValue] = useState("");
    const [isCodeError, setIsCodeError] = useState(false);
    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);
    const [isPhone, setIsPhone] = useState(false);
    const [resendCodeTimer, setResendCodeTimer] = useState(60);
    const [resendCodeCheck, setResendCodeCheck] = useState(true);

    const intervalId = useRef(null);

    useEffect(() => {
        if (localStorage.getItem("emailPhoneVal")) {
            if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
                setIsPhone(false);
            } else if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
                setIsPhone(true);
            }
            if (resendCodeCheck && resendCodeTimer > 0) {
                intervalId.current = setInterval(
                    () => setResendCodeTimer((prev) => prev - 1),
                    1000
                );
            } else if (!resendCodeCheck || resendCodeTimer === 0) {
                clearInterval(intervalId.current);
            }

            if (resendCodeTimer === 0) {
                setResendCodeCheck(false);
            }
            return () => clearInterval(intervalId.current);
        }

    }, [resendCodeCheck, resendCodeTimer]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoaderActive(true);
        if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
            let formData = new FormData();
            formData.append(
                "phone_code_id_int",
                parseInt(localStorage.getItem("countryCodeVal"))
            );
            formData.append(
                "phone_number_int",
                parseInt(localStorage.getItem("emailPhoneVal"))
            );
            formData.append("email_chr", "");
            formData.append("security_code_chr", otp);

            dispatch(
                verifySecurityCodeApi(
                    formData,
                    (res) => {
                        setOtp("");
                        localStorage.setItem("security_code_chr", res.data.data.security_code_chr)
                        navigate("/login");
                        setLoaderActive(false);
                    },
                    (err) => {
                        setLoaderActive(false);
                        setIsCodeError(true);
                    }
                )
            );
        } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
            let formData = new FormData();
            formData.append("phone_code_id_int", 0);
            formData.append("phone_number_int", 0);
            formData.append("email_chr", localStorage.getItem("emailPhoneVal"));
            formData.append("security_code_chr", otp);

            dispatch(
                verifySecurityCodeApi(
                    formData,
                    (res) => {
                        setOtp("");
                        localStorage.setItem("security_code_chr", res.data.data.security_code_chr)
                        navigate("/login");
                        setLoaderActive(false);
                    },
                    (err) => {
                        setLoaderActive(false);
                        setIsCodeError(true);
                    }
                )
            );
        }
    };

    function handleMoveToSignUp() {
        navigate("/login", { replace: true });
    }

    function handleValidateCode(e) {
        setIsCodeError(false);
        setRecievedCodeValue(e.target.value);
    }

    const resendCodeActivation = () => {
        if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
            let formData = new FormData();
            formData.append(
                "phone_code_id_int",
                parseInt(localStorage.getItem("countryCodeVal"))
            );
            formData.append(
                "phone_number_int",
                parseInt(localStorage.getItem("emailPhoneVal"))
            );
            formData.append("email_chr", "");

            dispatch(
                resendCode(
                    formData,
                    (res) => {
                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        setHandleToaster(true);

                        setResendCodeCheck(true);
                        setResendCodeTimer(60);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    },
                    (err) => {
                        setResponceMsg(err.data.message);
                        setToasterType("error");
                        setHandleToaster(true);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
            let formData = new FormData();
            formData.append("phone_code_id_int", 0);
            formData.append("phone_number_int", 0);
            formData.append("email_chr", localStorage.getItem("emailPhoneVal"));

            dispatch(
                resendCode(
                    formData,
                    (res) => {
                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        setHandleToaster(true);

                        setResendCodeCheck(true);
                        setResendCodeTimer(60);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    },
                    (err) => {
                        setResponceMsg(err.data.message);
                        setToasterType("error");
                        setHandleToaster(true);

                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        }
    };
    const [otp, setOtp] = useState("");

    const handleOtp = (e) => {
        setOtp(e.target.value);
    };

    const handleActivateUser = (e) => {
        e.preventDefault();

        if (recievedCodeValue) {
            if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {

                setLoaderActive(true);

                let formData = new FormData();
                formData.append("phone_code_id_int", parseInt(localStorage.getItem("countryCodeVal")) || 1);
                formData.append("phone_number_int", parseInt(localStorage.getItem("emailPhoneVal")) || 0);
                formData.append("email_chr", "");
                formData.append("otp_chr", recievedCodeValue?.trim());
                localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));

                dispatch(
                    activateUser(formData, (res) => {
                        // openNotification('success', 'topRight', res.data.message)
                        localStorage.setItem("receiverPlatform", parseInt(localStorage.getItem("emailPhoneVal")));
                        localStorage.setItem(
                            "receiverPlatformPhoneCode",
                            parseInt(localStorage.getItem("countryCodeVal"))
                        );

                        dispatch(setIsSignUpFlagTrue());

                        setResponceMsg(res.data.message);
                        setLoaderActive(false);
                        setToasterType("success");
                        setHandleToaster(true);

                        if (res?.data?.login_flag) {
                            handleAuthentication(res.data)
                        }
                    },
                        (error) => {
                            console.log(error.data.message)
                            // openNotification('failed', 'topRight', error.data.message)
                            setResponceMsg(error.data.message);
                            setToasterType("errror");
                            setHandleToaster(true);
                            setLoaderActive(false);

                            setIsCodeError(true)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                );
            }

            else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
                setLoaderActive(true);


                let formData = new FormData();
                // parseInt(countryCode) && formData.append("phone_code_id_int",  0);
                // parseInt(phonenumber) && formData.append("phone_number_int", 0);
                formData.append("email_chr", localStorage.getItem("emailPhoneVal"));
                formData.append("otp_chr", recievedCodeValue?.trim());
                localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));

                dispatch(
                    activateUser(
                        formData,
                        (res) => {
                            localStorage.setItem("receiverPlatform", localStorage.getItem("emailPhoneVal"));
                            setLoaderActive(false);

                            dispatch(setIsSignUpFlagTrue());

                            setResponceMsg(res.data.message);
                            setToasterType("success");

                            setHandleToaster(true);

                            if (res?.data?.login_flag) {
                                handleAuthentication(res.data)
                            }
                        },
                        (error) => {
                            console.log(error)

                            setIsCodeError(true)

                            setLoaderActive(false);
                            setToasterType("error");
                            setResponceMsg(error.data.message);
                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    ))
            }
        } else {
            setIsCodeError(true)
        }

    }

    const handleAuthentication = (data) => {
        setLoaderActive(false);
        dispatch(authenticate());
        dispatch(setUserDetails(data));

        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("refresh_token", data.refresh_token);
        localStorage.setItem("user_id", data.data.user_id_ids);
        localStorage.setItem("roleId", data.data.role_id_ids);
        localStorage.setItem("fullName",
            data.data.first_name_chr + " " + data.data.last_name_chr
        );
        navigate("/dashboard", { replace: true });
    };

    return (
        <>
            <>
                <div className="" >
                    <div className="row  align-items-center justify-contain-center bg-login">
                        <div className="col-xl-12 ">
                            <div className=" border-0">
                                <div className=" login-bx">
                                    <div className="row custome-row">
                                        <div
                                            className="col-xl-6 col-md-6  text-center d-flex justify-content-center align-items-center"
                                            style={{ height: '100dvh' }}>
                                            <img src={outerMainBannerImg} style={{ width: "100%", height: '100%', objectFit: "cover" }} alt="" />
                                        </div>


                                        <div
                                            className="col-xl-6 col-md-6  d-flex cutome-col justify-content-center align-items-center overflow-auto "
                                            style={{ height: '100dvh' }}
                                        >

                                            <div
                                                className="sign-in-your d-flex justify-content-center"
                                            >
                                                <div className="w-100">
                                                    <div className="row d-flex justify-content-center mt-2">
                                                        <img
                                                            src={logo}
                                                            style={{ width: "108px", cursor: "pointer" }}
                                                            alt=""
                                                            onClick={() => navigate("/login")}
                                                            className="cursor-pointer"
                                                        />
                                                    </div>

                                                    <div className="row mt-1">
                                                        <span className="login-subtitle">
                                                            {txtANewWay}
                                                        </span>
                                                    </div>

                                                    <div className="row">
                                                        <div className="row my-3">
                                                            <span className="login-title" style={{ color: 'black' }}>
                                                                {`Verification code`}
                                                            </span>
                                                        </div>

                                                        <div className="row mx-0 mb-4">
                                                            <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center flex-column">
                                                                <span>{`We sent the verification code to`}</span>
                                                                <span className="fs-6 font-w600 text-black">{localStorage.getItem("emailPhoneVal")}</span>
                                                            </div>
                                                        </div>


                                                        <form onSubmit={handleActivateUser} autoComplete={false}>

                                                            <div className="row">
                                                                <InputField
                                                                    labelName={hintEnterValidationCode}
                                                                    placeholderName={hintEnterValidationCode}
                                                                    value={recievedCodeValue}
                                                                    onChange={handleValidateCode}
                                                                    errorOccured={isCodeError}
                                                                    errorMeesage={"Invalid code"}
                                                                    onBlur={() => { }}
                                                                />
                                                            </div>

                                                            <PrimaryButton
                                                                buttonName={btnVerify}
                                                                type={"submit"}
                                                                onClick={handleActivateUser}
                                                                isLoading={loaderActive}
                                                                loadingMessage={"Loading..."}
                                                                style={{
                                                                    width: "100%",
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                }}
                                                            />
                                                        </form>

                                                        {resendCodeCheck && <div className="row mt-3  text-center">
                                                            <span>
                                                                {" "}
                                                                Didn't receive the code? You can request a new code <br></br>to be
                                                                sent in 00:
                                                                {resendCodeTimer > 9 ? resendCodeTimer : "0" + resendCodeTimer}{" "}
                                                            </span>
                                                        </div>}
                                                        <div className="row mt-3">
                                                            <div className=" d-flex justify-content-center">
                                                                <span
                                                                    onClick={resendCodeActivation}
                                                                    style={{
                                                                        color: "orange",
                                                                        fontWeight: "700",
                                                                        pointerEvents: resendCodeCheck ? "none" : "auto",
                                                                        opacity: resendCodeCheck ? "0.5" : "1",
                                                                        cursor: "pointer",
                                                                    }}>
                                                                    {btnResendCode}

                                                                </span>
                                                            </div>
                                                        </div>

                                                        {<div className="separator-custom my-3">
                                                            <div
                                                                className="line-custom me-3"></div>
                                                            <span className="text-custom fs-6">{btnAlreadyAUser}</span>
                                                            <div
                                                                className="line-custom ms-3"></div>
                                                        </div>}


                                                        <div className="">
                                                            {<PrimaryButton
                                                                buttonName={"LOG IN"}
                                                                className={"mb-3"}
                                                                loadingMessage={"Loading..."}
                                                                style={{
                                                                    width: "100%",
                                                                    background: '#fff',
                                                                    border: '1px solid rgb(199, 212, 234) ',
                                                                    boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                                    color: "black",
                                                                    fontWeight: 600
                                                                }}
                                                                onClick={() => {
                                                                    navigate("/login");
                                                                }}
                                                            />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

            {handleToaster && (
                <ResponceToaster toasterType={toasterType} message={responceMsg} />
            )}
        </>
    );
};

export default ActivateUser;
